var color = {
    // Primary Palette
    StarRezBrandColors: {
        Blue60: "#0076E0",
        Grey30: "#DAE5EC",
        Grey80: "#12374E",
        WhiteSR: "white",
        YellowSR: "#FFF100",
    },
    Grey: {
        G100: "#020F18",
        G90: "#072131",
        // tslint:disable-next-line: object-literal-sort-keys
        G80: "#12374E",
        G70: "#516878",
        G60: "#6D748D",
        G50: "#C4C9D2",
        G40: "#C8D3DA",
        G30: "#DAE5EC",
        G20: "#EDF2F5",
        G10: "#F6F8FA",
    },
    // Secondary Palette
    Blue: {
        B100: "#00398D",
        B80: "#0341E0",
        // tslint:disable-next-line: object-literal-sort-keys
        B60: "#0075DB",
        B40: "#B4E1FA",
        B20: "#EBF6FF",
    },
    Green: {
        G100: "#003A1B",
        G80: "#038215",
        // tslint:disable-next-line: object-literal-sort-keys
        G60: "#50B83C",
        G40: "#BBE5B3",
        G20: "#E3F1DF",
    },
    Orange: {
        O100: "#4A1504",
        O80: "#C05717",
        // tslint:disable-next-line: object-literal-sort-keys
        O60: "#FB7C39",
        O40: "#FFC58B",
        O20: "#FCEBDB",
    },
    Pink: {
        P100: "#58002C",
        P80: "#A21950",
        // tslint:disable-next-line: object-literal-sort-keys
        P60: "#D22866",
        P40: "#FEA0C0",
        P20: "#FFCFE2",
    },
    Purple: {
        P100: "#1F0481",
        P80: "#4319D6",
        // tslint:disable-next-line: object-literal-sort-keys
        P60: "#6A43F3",
        P40: "#DED6FC",
        P20: "#F6F0FD",
    },
    Red: {
        R100: "#4F0407",
        R80: "#A5191F",
        // tslint:disable-next-line: object-literal-sort-keys
        R60: "#E1272F",
        R40: "#FEAD9A",
        R20: "#FBEAE5",
    },
    Teal: {
        T100: "#003135",
        T80: "#00828C",
        // tslint:disable-next-line: object-literal-sort-keys
        T60: "#47C1BF",
        T40: "#B7ECEC",
        T20: "#E0F5F5",
    },
    Yellow: {
        Y100: "#573B00",
        Y80: "#8A6116",
        // tslint:disable-next-line: object-literal-sort-keys
        Y60: "#EEC200",
        Y40: "#FFF0B3",
        Y20: "#FFFBEC",
    },
};

var scheme = {
    // Primary Palette
    StarRezBrandColors: {
        BlueRegular: {
            backgroundColor: color.StarRezBrandColors.Blue60,
            color: "white",
        },
        WhiteRegular: {
            backgroundColor: color.StarRezBrandColors.WhiteSR,
            color: color.StarRezBrandColors.Grey80,
        },
        // tslint:disable-next-line: object-literal-sort-keys
        GreyDarker: {
            backgroundColor: color.StarRezBrandColors.Grey80,
            color: "white",
        },
        GreyLighter: {
            backgroundColor: color.StarRezBrandColors.Grey30,
            color: color.StarRezBrandColors.Grey80,
        },
        YellowRegular: {
            backgroundColor: color.StarRezBrandColors.YellowSR,
            color: color.StarRezBrandColors.Grey80,
        },
    },
    Grey: {
        Darkest: {
            backgroundColor: color.Grey.G100,
            color: "white",
        },
        UltraDark: {
            backgroundColor: color.Grey.G90,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Darker: {
            backgroundColor: color.Grey.G80,
            color: "white",
        },
        Dark: {
            backgroundColor: color.Grey.G70,
            color: "white",
        },
        RegularDark: {
            backgroundColor: color.Grey.G60,
            color: "white",
        },
        RegularLight: {
            backgroundColor: color.Grey.G50,
            color: color.Grey.G80,
        },
        Light: {
            backgroundColor: color.Grey.G40,
            color: color.Grey.G80,
        },
        Lighter: {
            backgroundColor: color.Grey.G30,
            color: color.Grey.G80,
        },
        UltraLight: {
            backgroundColor: color.Grey.G20,
            color: color.Grey.G80,
        },
        Lightest: {
            backgroundColor: color.Grey.G10,
            color: color.Grey.G80,
        },
    },
    // Secondary Palette
    Blue: {
        Darker: {
            backgroundColor: color.Blue.B100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Blue.B80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Blue.B60,
            color: "white",
        },
        Light: {
            backgroundColor: color.Blue.B40,
            color: color.Blue.B100,
        },
        Lighter: {
            backgroundColor: color.Blue.B20,
            color: color.Blue.B100,
        },
    },
    Green: {
        Darker: {
            backgroundColor: color.Green.G100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Green.G80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Green.G60,
            color: color.Green.G100,
        },
        Light: {
            backgroundColor: color.Green.G40,
            color: color.Green.G100,
        },
        Lighter: {
            backgroundColor: color.Green.G20,
            color: color.Green.G100,
        },
    },
    Orange: {
        Darker: {
            backgroundColor: color.Orange.O100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Orange.O80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Orange.O60,
            color: color.Orange.O100,
        },
        Light: {
            backgroundColor: color.Orange.O40,
            color: color.Orange.O100,
        },
        Lighter: {
            backgroundColor: color.Orange.O20,
            color: color.Orange.O100,
        },
    },
    Pink: {
        Darker: {
            backgroundColor: color.Pink.P100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Pink.P80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Pink.P60,
            color: "white",
        },
        Light: {
            backgroundColor: color.Pink.P40,
            color: color.Pink.P100,
        },
        Lighter: {
            backgroundColor: color.Pink.P20,
            color: color.Pink.P100,
        },
    },
    Purple: {
        Darker: {
            backgroundColor: color.Purple.P100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Purple.P80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Purple.P60,
            color: "white",
        },
        Light: {
            backgroundColor: color.Purple.P40,
            color: color.Purple.P100,
        },
        Lighter: {
            backgroundColor: color.Purple.P20,
            color: color.Grey.G80,
        },
    },
    Red: {
        Darker: {
            backgroundColor: color.Red.R100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Red.R80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Red.R60,
            color: "white",
        },
        Light: {
            backgroundColor: color.Red.R40,
            color: color.Red.R100,
        },
        Lighter: {
            backgroundColor: color.Red.R20,
            color: color.Red.R100,
        },
    },
    Teal: {
        Darker: {
            backgroundColor: color.Teal.T100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Teal.T80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Teal.T60,
            color: color.Teal.T100,
        },
        Light: {
            backgroundColor: color.Teal.T40,
            color: color.Teal.T100,
        },
        Lighter: {
            backgroundColor: color.Teal.T20,
            color: color.Teal.T100,
        },
    },
    Yellow: {
        Darker: {
            backgroundColor: color.Yellow.Y100,
            color: "white",
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Yellow.Y80,
            color: "white",
        },
        Regular: {
            backgroundColor: color.Yellow.Y60,
            color: color.Yellow.Y100,
        },
        Light: {
            backgroundColor: color.Yellow.Y40,
            color: color.Yellow.Y100,
        },
        Lighter: {
            backgroundColor: color.Yellow.Y20,
            color: color.Yellow.Y100,
        },
    },
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var fontFamily = "Roboto, Arial, Helvetica, sans-serif";
var fontStyles = function (size, weight) {
    if (weight === void 0) { weight = "normal"; }
    return ({
        fontFamily: fontFamily,
        fontStyle: "normal",
        fontWeight: weight,
        fontSize: "" + size,
        lineHeight: "130%",
        letterSpacing: "0.02em",
        color: color.Grey.G80,
    });
};
var FontTypes = [
    "xSmall.regular",
    "small.regular",
    "small.medium",
    "small.bold",
    "small.allCaps",
    "normal.regular",
    "normal.medium",
    "normal.bold",
    "normal.allCaps",
    "intermediate.medium",
    "large.regular",
    "large.medium",
    "large.bold",
    "large.allCaps",
    "xLarge.regular",
    "xLarge.medium",
    "xLarge.bold",
    "xxxLarge.bold"
];
var fontTypeToObject = function (type) {
    var item = type.split(".");
    return font[item[0]][item[1]];
};
var font = {
    xSmall: {
        regular: __assign({}, fontStyles("9px")),
    },
    small: {
        regular: __assign({}, fontStyles("12px")),
        medium: __assign({}, fontStyles("12px", 500)),
        bold: __assign({}, fontStyles("12px", "bold")),
        allCaps: __assign(__assign({}, fontStyles("12px", "bold")), { textTransform: "uppercase" })
    },
    normal: {
        regular: __assign({}, fontStyles("14px")),
        medium: __assign({}, fontStyles("14px", 500)),
        bold: __assign({}, fontStyles("14px", "bold")),
        allCaps: __assign(__assign({}, fontStyles("14px", "bold")), { textTransform: "uppercase" })
    },
    intermediate: {
        medium: __assign({}, fontStyles("15px", 500)),
    },
    large: {
        regular: __assign({}, fontStyles("16px")),
        medium: __assign({}, fontStyles("16px", 500)),
        bold: __assign({}, fontStyles("16px", "bold")),
        allCaps: __assign(__assign({}, fontStyles("16px", "bold")), { textTransform: "uppercase" })
    },
    xLarge: {
        regular: __assign({}, fontStyles("20px")),
        medium: __assign({}, fontStyles("20px", 500)),
        bold: __assign({}, fontStyles("20px", "bold")),
    },
    xxxLarge: {
        bold: __assign({}, fontStyles("48px", "bold")),
    },
};

var size = {
    none: "0",
    xxxsmall: "2px",
    xxsmall: "4px",
    xsmall: "8px",
    small: "16px",
    medium: "24px",
    large: "40px",
    xlarge: "56px",
    xxlarge: "72px",
    xxxlarge: "90px",
};

var button = {
    radius: '4px',
};

export { FontTypes, button, color, font, fontTypeToObject, scheme, size };
//# sourceMappingURL=theme.esm.js.map
